/*
 * @Description: 
 * @Author: Liu Yang
 * @Date: 2021-08-23 10:36:13
 * @LastEditTime: 2021-08-23 10:38:32
 * @LastEditors: Liu Yang
 * @FilePath: \earth-vue\src\store\modules\homePage.js
 */
// @ homePage
import {
  REQUEST_BANNER,
  REQUEST_TIMENUMS,
  REQUEST_IMGHOMEPAGE,

} from '../mutation-types'

const state = {
  name: ""
}

const mutations = {
}

const actions = {
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
